import type { MechKey } from './keys';

export const ro: Partial<Record<MechKey, string>> = {
  'app.eyebrow': 'Mecanică · 2D',
  'panel.scene': 'Scenă',
  'panel.dims': 'Parametri',
  'panel.style': 'Aspect',
  'panel.action': 'Comenzi',
  'style.body': 'Corp',
  'style.vector': 'Vectori',
  'style.ground': 'Sol',
  'style.forces': 'Afișează forțele',
  'style.trace': 'Afișează traseul',
  'style.labels': 'Etichete vectori',
  'hint.line1': 'Click play pentru a porni · trage corpurile pentru a le muta',
  'hint.line2': 'Sandbox: alege o formă, apoi click pentru a o plasa',
  'scene.incline': 'Plan înclinat',
  'scene.projectile': 'Mișcare balistică',
  'scene.pendulum': 'Pendul',
  'scene.springMass': 'Sistem masă-resort',
  'scene.collisions': 'Coliziuni',
  'scene.atwood': 'Mașina Atwood',
  'scene.circular': 'Mișcare circulară',
  'scene.sandbox': 'Mediu liber',
  'dim.angle': 'unghi (°)',
  'dim.friction': 'frecare',
  'dim.mass': 'masă',
  'dim.massA': 'masă A',
  'dim.massB': 'masă B',
  'dim.velocity': 'viteză',
  'dim.angleLaunch': 'unghi lansare (°)',
  'dim.gravity': 'gravitație',
  'dim.gravityX': 'gravitație x',
  'dim.gravityY': 'gravitație y',
  'dim.length': 'lungime',
  'dim.damping': 'amortizare',
  'dim.spring': 'rigiditate',
  'dim.restitution': 'restituție',
  'dim.radius': 'rază',
  'dim.speed': 'viteză',
  'action.play': 'Rulează',
  'action.pause': 'Pauză',
  'action.step': 'Pas',
  'action.reset': 'Resetează',
  'action.speed': 'Viteză',
  'action.clear': 'Șterge',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': 'Gravitație',
  'forceName.normal': 'Normală',
  'forceName.friction': 'Frecare',
  'forceName.tension': 'Tensiune',
  'forceName.spring': 'Resort',
  'forceName.applied': 'Aplicată',
  'forceName.air': 'Frecare aer',
  'palette.box': 'Cub',
  'palette.circle': 'Bilă',
  'palette.ramp': 'Plan',
  'palette.ground': 'Sol',
  'palette.hint': 'Alege o formă, apoi click pe canvas pentru a o plasa.',
  'panel.forces': 'Forțe observate',
  'forces.empty': 'Niciuna încă — rulează scena',
};
